import { Component, OnInit } from '@angular/core';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { FormGroup } from '@angular/forms';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { CheckboxService } from '../checkbox/checkbox.service';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GlobalDialogComponent } from '../globaldialog/globaldialog.component';

@Component({
  selector: 'date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  providers: [DatePipe],
})
export class DateInputComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  maxDate: Date;
  minDate: Date;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.maxDate = this.field.dateConfig.maxDate;
    this.minDate = this.field.dateConfig.minDate;
  }

  showDateChangeAlert(field: FieldConfig) {
    if (field?.alert?.active) {
      this.dialog.open(GlobalDialogComponent, {
        height: '300px',
        disableClose: true,
        panelClass: 'clientAlertPopup-panel',
        data: {
          title: field?.alert?.title,
          content:field?.alert?.content,
          info: false,
          alert: true,
          closeIcon: false,
        },
      });
    }
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue =
      this.group.controls[this.field.name].value === undefined
        ? normalizedYear
        : moment(this.group.controls[this.field.name].value);
    ctrlValue.year(normalizedYear.year());
    this.group.controls[this.field.name].setValue(ctrlValue);
  }

  chosenMonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = moment(this.group.controls[this.field.name].value);
    ctrlValue.month(normalizedMonth.month());
    this.group.controls[this.field.name].setValue(ctrlValue);
    if (this.field.dateConfig?.yearAndMonth) datepicker.close();
  }

  error(validation) {
    let ret = false;
    if (this.group.get(this.field.name).hasError(validation.name)) {
      if (this.group.value[this.field.name] != undefined) {
        ret = true;
      }
    }
    return ret;
  }
}
